import { motion } from "framer-motion";
import { FiPlusCircle, FiMinusCircle } from "react-icons/fi";
import { useState } from "react";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I choose the right product for my hair type?",
      answer:
        "We recommend taking our Hair Quiz to get personalized product recommendations based on your hair type and concerns. You can also contact our team for expert advice.",
    },
    {
      question: "How long does shipping take?",
      answer:
        "Standard shipping within Ghana takes 2-4 business days. International shipping times vary by location. Check our Shipping Policy for detailed information.",
    },
    {
      question: "What is your return policy?",
      answer:
        "We offer a 30-day return policy for unused products in their original packaging. Please see our Returns & Exchanges page for full details.",
    },
    {
      question: "Are your products natural and organic?",
      answer:
        "Yes, we use premium natural ingredients in all our products. Each product is carefully formulated to provide the best results while being gentle on your hair.",
    },
    {
      question: "Do you offer international shipping?",
      answer:
        "Yes, we ship to select countries internationally. Shipping times and costs vary by location. Please check our Shipping Policy for more details.",
    },
    {
      question: "How often should I wash my hair?",
      answer:
        "The frequency of washing depends on your hair type and lifestyle. Generally, we recommend washing 1-2 times per week to maintain healthy hair and scalp.",
    },
    {
      question: "Can I use multiple products together?",
      answer:
        "Yes, our products are designed to work together. We recommend following our suggested hair care routines for the best results.",
    },
    {
      question: "Do you offer samples?",
      answer:
        "Yes, we offer sample sizes of selected products. Check our product pages or contact customer service for availability.",
    },
    {
      question: "How long do products typically last?",
      answer:
        "Product longevity varies based on usage, but most products last 2-3 months with regular use following recommended amounts.",
    },
    {
      question: "Do you have a loyalty program?",
      answer:
        "Yes, join our rewards program to earn points on purchases, receive exclusive offers, and get early access to new products.",
    },
  ];

  return (
    <div className="bg-gray-50 pt-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-serif font-bold text-[#DB5461] mb-4">
            Frequently Asked Questions
          </h1>
          <div className="w-24 h-1 bg-[#DB5461] mx-auto rounded-full mb-6" />
          <p className="text-lg text-gray-600">
            Find answers to common questions about our products and services
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className={`w-full px-6 py-4 flex justify-between items-center transition-colors duration-300 ${
                  openIndex === index
                    ? "bg-[#DB5461]/10 text-[#DB5461]"
                    : "hover:bg-gray-50"
                }`}
              >
                <h3
                  className={`text-lg font-semibold ${
                    openIndex === index ? "text-[#DB5461]" : "text-gray-900"
                  }`}
                >
                  {faq.question}
                </h3>
                {openIndex === index ? (
                  <FiMinusCircle className="h-5 w-5 text-[#DB5461]" />
                ) : (
                  <FiPlusCircle className="h-5 w-5 text-[#DB5461]" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 bg-white">
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="mt-12 text-center"
        >
          <p className="text-gray-600">
            Still have questions?{" "}
            <a
              href="/contact"
              className="text-[#DB5461] hover:text-[#DB5461]/80"
            >
              Contact our support team
            </a>
          </p>
        </motion.div>
      </div>
    </div>
  );
}
